export interface IBusinessOpportunityRoute {
  _id: string
  name: string
  type: string
}

export interface IBusinessOpportunity {
  workflow: string
  route: { [key: string]: any }
  commodity: string[]
  typeCommodity: string
  typeReefer: string
  goodType: string
  typeDangerous: string
  typeFragileGoods: string
  vehicleCategory?: string | null
  vehicleCategoryName?: string | null
  contCategory?: string | null
  quote: string
  productivity: number | null
  weightCommodity: null | number
  commodityDetail?: any
  workflowDetail?: any
  transportation?: any
  positions: Array<{ [key: string]: any }>
  theSamePositions: Array<[key: number]>
}
export interface IMoocSavingPolicy {
  freeHourNumber: number | null
  moocKeepHourly: number | null
  moocKeepOvernight: number | null
  calculatedByHourNextDay: string | number | null
  moocKeepLongTerm: number | null
  calculatedFromEvening: number | null
}
export interface IOtherSurchargePolicy {
  towingContainerSunday: number | null
  towingContainerHoliday: number | null
}
export interface IReeferPluginCharges {
  reeferPluginChargesGenerator: number | null
}
export interface ICooperatorPolicy {
  moocSavingPolicy: IMoocSavingPolicy
  otherSurchargePolicy: IOtherSurchargePolicy
  reeferPluginCharges: IReeferPluginCharges
}

export interface ICooperatorDocument {
  dayOfTheMonth?: number | null
  monthsCreditTerms?: number | null
  duration: number | null
  spendingLimit: number | null
  cooperatorDocument: File | undefined
  fileName: string
  description: string
  type: string
  dueDate?: string
  creditTermsBy: string
  effectiveDate?: string
  stopEffect?: string | boolean | null
  contractStatus?: string | number | null
  isSendEmailApprover?: boolean
  createContract?: boolean
  emailedApprove?: boolean
  contractFor?: string | null
  fileOriginName?: string | null
}

export interface IDataCooperator {
  _id: string
  name: string
  taxNumber: string
  email: string
  website?: null
  address?: null
  fax?: null
  phone: {
    countryCode: string
    phone: string
    code: string
  }
  office?: null
  representation?: null
  curator?: string
  countryName: string
  countryCode: string
  cityCode: string
  cityName: string
  districtCode: string
  districtName: string
  wardCode: string
  wardName: string
  locationName: string
  commission: number
  isSendMail: boolean
  markup: null
  type: [string | null]
  cooperatorPolicy: ICooperatorPolicy
}
export interface IAddCooperator {
  name: string
  abbreviationName: string
  taxNumber: string
  email: string
  website?: string
  address?: string
  fax?: string
  phone: {
    countryCode: string
    phone: string
    code: string
  }
  office?: string
  representation?: string
  curator?: string
  curatorName?: string
  distribution?: string
  distributionName?: string
  locationName: string
  location: {
    lat: number
    lng: number
  } | null
  commission: number | null
  isSendMail: boolean
  markup: number | string | null
  emailConfirmMarkup: string
  type: Array<[] | string>
  moocSavingPolicy: IMoocSavingPolicy
  otherSurchargePolicy: IOtherSurchargePolicy
  reeferPluginCharges: IReeferPluginCharges
  emailInvite: null | string
}
export interface IEditCooperator {
  name: string
  abbreviationName: string
  taxNumber: string
  email: string
  website?: string
  address?: string
  fax?: string
  phone: {
    countryCode: string
    phone: string
    code: string
  }
  office?: string
  representation?: string
  curator?: string
  curatorName?: string
  distribution?: string
  distributionName?: string
  commission: number | null
  isSendMail: boolean
  markup: number | string | null
  statusMarkup: boolean
  statusConfirmMarkup: number | null
  type: Array<[] | string>
  cooperatorPolicy: ICooperatorPolicy
  locationName: string
  location: {
    lat: number
    lng: number
  } | null
  sentInviteJoinSystem?: boolean
  invitationStatus?: boolean
  workspaceCustomer?: string
}

export interface IAddCommodity {
  cooperator: string
  commodity: string
  category: string
  businessOpportunity: string | undefined
}
export interface IContactCooperator {
  cooperator: string
  fullName: string
  phone: {
    countryCode: string
    phone: string
    code: string
  }
  email: string
  office: string
  department: string
  birthday: string
}

export interface IEditCommodity {
  cooperator: string
  commodity: string
  category: string
}

export interface IDataCommodity {
  _id: string
  cooperator: string
  commodity: string
  category: string
}

const rulesCustomer = {
  name: 'required',
  taxNumber: 'required',
  website: 'regexUrl',
  markup: 'min_value:0'
}
const initCustomer = {
  name: null,
  taxNumber: null,
  email: null,
  website: null,
  address: null,
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  },
  fax: null,
  cityName: null,
  districtName: null,
  wardName: null,
  commission: null,
  isSendMail: false,
  markup: null,
  type: [],
  dayOfTheMonth: null,
  duration: null,
  spendingLimit: null,
  isReeferPluginChargesGenerator: false,
  isTowingContainerSunday: false,
  isTowingContainerHoliday: false,
  isFreeHour: false,
  isMoocSavingHourly: false,
  isMoocSavingOvernight: false,
  isMoocSavingLongTerm: false,
  keepMoocByHours: {},
  moocKeepHourly: {},
  moocKeepOvernight: {},
  moocKeepLongTerm: [
    {
      from: 1,
      to: null,
      value1: null,
      value2: null
    }
  ]
}

const rulesEditCustomer = {
  name: 'required',
  taxNumber: 'required',
  website: 'regexUrl',
  phone: 'required',
  markup: 'min_value:0',
  location: 'required'
}

const initEditCustomer = {
  name: null,
  taxNumber: null,
  website: null,
  address: null,
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  },
  fax: null,
  type: ['VENDOR'],
  cityName: null,
  districtName: null,
  wardName: null,
  commission: null,
  markup: null,
  dayOfTheMonth: null,
  duration: null,
  spendingLimit: null,
  isSendMail: false,
  cooperatorPolicy: {
    moocSavingPolicy: {
      freeHourNumber: 0,
      moocKeepHourly: 0,
      moocKeepOvernight: 0,
      calculatedByHourNextDay: '00:00:00',
      moocKeepLongTerm: 0,
      calculatedFromEvening: 0
    },
    otherSurchargePolicy: {
      towingContainerSunday: 0,
      towingContainerHoliday: 0
    },
    reeferPluginCharges: {
      reeferPluginChargesGenerator: 0
    }
  }
}

export default {
  rulesCustomer,
  initCustomer,
  initEditCustomer,
  rulesEditCustomer
}
